import {
  addDays,
  addHours,
  format,
  isSameDay,
  startOfDay,
  toDate
} from 'date-fns'
import {ru} from 'date-fns/locale'
import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {cn} from '@containers/html-utils'
import {Shift, useCalendarStore} from '../../calendar-store'
import {validDateFormat} from '../../utils'
import {AddTask} from '../add-task/add-task'

const HeaderDaysTw = tw.div`
  sticky
  top-0
  z-30
  flex
  min-w-full
  items-center
  border
  border-solid
  border-input-disabled
  bg-main-old
  w-max
  border-l-0
  border-t-0
  border-r-0
  h-40
`

const HeaderDayTw = tw.div`
  flex
  justify-center
  min-w-200
  grow-0
  basis-1/7
  w-1/7
  text-secondary-old
  capitalize
  h-full
  items-center
`

const weekFormat = 'EEEEEE'
const dayFormat = 'd'

interface Props {
  shift: Shift
}

export const HeaderDays = observer(({shift}: Props) => {
  const [state, store] = useCalendarStore()
  const language = Lang.getLang()
  const itemsRef = useRef([])

  return (
    <HeaderDaysTw>
      {new Array(7).fill(null).map((_, i) => {
        const start = startOfDay(addDays(store.startDate(shift), i))
        return (
          <HeaderDayTw key={i}>
            <Dropdown
              animation={false}
              duration={0}
              visible={
                format(addDays(store.startDate(shift), i), dayFormat) ===
                  validDateFormat(state.showPopupButton.hour, dayFormat) &&
                state.openedAllDayPopup
              }
              content={<AddTask allDay start={start} end={start} />}
              reference={itemsRef.current[i]}
            />
            <div
              className="flex w-full items-center justify-center"
              key={i}
              ref={el => (itemsRef.current[i] = el)}
              data-day={addHours(start, 12)}
              onClick={() => {
                store.showedPopupButton(true, start)
                store.setOpenedAllDayPopup(true)
              }}
            >
              {format(addDays(store.startDate(shift), i), weekFormat, {
                locale: language === 'ru' && ru
              })}
              <div className="w-4" data-day={addHours(start, 12)} />
              {isSameDay(
                addDays(store.startDate(shift), i),
                toDate(Time.now())
              ) ? (
                <span
                  className="relative flex grow-0 w-24 h-24 rounded-full bg-accent-old"
                  data-day={addHours(start, 12)}
                >
                  <span
                    data-day={addHours(start, 12)}
                    className={cn(
                      'text-12 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold',
                      isSameDay(
                        addDays(store.startDate(shift), i),
                        toDate(Time.now())
                      ) && 'text-on-color'
                    )}
                  >
                    {format(addDays(store.startDate(shift), i), dayFormat)}
                  </span>
                </span>
              ) : (
                <span data-day={addHours(start, 12)}>
                  {format(addDays(store.startDate(shift), i), dayFormat)}
                </span>
              )}
            </div>
          </HeaderDayTw>
        )
      })}
    </HeaderDaysTw>
  )
})
